import CheckIn from './checkin'
import CheckInSimulated from './checkin-simulated'
import CheckInProjection from './checkin-projection'

export default CheckIn
export { CheckInSimulated, CheckInProjection }
